import { NominationProgress } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationProgress: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationProgress> = (fetchContext, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/progress`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationProgress>(fetchContext.errorStore, response, 'get nomination progress'));
